import { Component, DOCUMENT, Inject, inject, Renderer2 } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NavbarMobileMenu } from '../navbar-mobile-menu/navbar-mobile-menu';

@Component({
  selector: 'app-navbar-mobile',
  imports: [NavbarMobileMenu, FontAwesomeModule],
  templateUrl: './navbar-mobile.html',
  styleUrl: './navbar-mobile.scss',
})
export class NavbarMobile {

  isNavbarOpen: boolean;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isNavbarOpen = false

    document = inject(DOCUMENT)
  }

  toggleMenu() {
    this.isNavbarOpen = !this.isNavbarOpen
    this.updateBodyScroll()
  }
  closeMenu() {
    this.isNavbarOpen = false;
    this.updateBodyScroll()
  }

  private updateBodyScroll() {
    if (this.isNavbarOpen) {
      this.renderer.addClass(this.document.body, 'navbar-no-scroll')
    } else {
      this.renderer.removeClass(this.document.body, 'navbar-no-scroll')
    }

  }

}
